import { render, staticRenderFns } from "./log-manage.vue?vue&type=template&id=2730c0f4&scoped=true"
import script from "./log-manage.vue?vue&type=script&lang=js"
export * from "./log-manage.vue?vue&type=script&lang=js"
import style0 from "./log-manage.vue?vue&type=style&index=0&id=2730c0f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2730c0f4",
  null
  
)

export default component.exports